import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import * as AT from './actionTypes';
import * as MT from './mutationsTypes';
import {
  PaginatedResult,
  FetchMrtRequest,
  UploadMachineReadableRequest,
  MachineReadableTemplate,
  MrtTemplateRequest,
  MrtUrlResponse
} from '../types';
import { SET_LOADER } from '../../organisation/store/mutationTypes';
import { IMrtState } from './state';
import { MrtService } from '../services';
/**
 * --------------------------------------------------
 *  MRT Actions
 * --------------------------------------------------
 **/
export const MrtActions: IMrtActions = {
  [AT.FETCH_MACHINE_READABLE_TEMPLATES]: (
    { commit },
    request: FetchMrtRequest
  ): Promise<PaginatedResult> => {
    commit(SET_LOADER, true);
    return MrtService.fetchMachineReadableTemplates(request).then(
      (paginatedResult: PaginatedResult) => {
        commit(MT.SET_MACHINE_READABLE_TEMPLATES, paginatedResult);
        commit(SET_LOADER, false);
        return paginatedResult;
      }
    );
  },
  [AT.UPLOAD_MACHINE_READABLE_TEMPLATES]: (
    { commit },
    request: UploadMachineReadableRequest
  ): Promise<MachineReadableTemplate> => {
    return MrtService.uploadMachineReadableTemplates(request).then(
      (mrt: MachineReadableTemplate) => {
        return mrt;
      }
    );
  },
  [AT.DOWNLOAD_MACHINE_READABLE_TEMPLATE]: (
    { commit },
    request: MrtTemplateRequest
  ): Promise<MrtUrlResponse> => {
    return MrtService.downloadMachineReadableTemplate(request).then(
      (res: MrtUrlResponse) => {
        return res;
      }
    );
  },
  [AT.DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE]: (
    { commit },
    request: MrtTemplateRequest
  ): Promise<MrtUrlResponse> => {
    return MrtService.downloadMachineReadableTemplateErrorFile(request).then(
      (res: MrtUrlResponse) => {
        return res;
      }
    );
  }
};

/**
 * --------------------------------------------------
 *  MRT Action Context Interface
 * --------------------------------------------------
 **/
export interface IMrtActionContext
  extends ActionContext<IMrtState, IRootState> {}

/**
 * --------------------------------------------------
 *  MRT Actions Interface
 * --------------------------------------------------
 **/
export interface IMrtActions extends ActionTree<IMrtState, IRootState> {
  [AT.FETCH_MACHINE_READABLE_TEMPLATES](
    context: IMrtActionContext,
    request: FetchMrtRequest
  ): Promise<PaginatedResult>;
  [AT.UPLOAD_MACHINE_READABLE_TEMPLATES](
    context: IMrtActionContext,
    request: UploadMachineReadableRequest
  ): Promise<MachineReadableTemplate>;
  [AT.DOWNLOAD_MACHINE_READABLE_TEMPLATE](
    context: IMrtActionContext,
    request: MrtTemplateRequest
  ): Promise<MrtUrlResponse>;
  [AT.DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE](
    context: IMrtActionContext,
    request: MrtTemplateRequest
  ): Promise<MrtUrlResponse>;
}
